module.exports = __webpack_public_path__ + "static/media/pngwing.com.ee88fa1e.png";